<template>
    <div>
        <dx-grid
            :url="url"
            :columns="columns"
            :title="title"
            :actions="actions"
            :beforeSetupGrid="beforeSetupGrid"
            :onLoaded="onLoaded"
            :getCustomTitle="getStatusText"
            ref="grid"
            :expandedOptions="{
                enabled: true,
                getTemplateName: getTemplateName,
            }"
            :paginate="true"
        ></dx-grid>
        <!-- <v-dialog v-model="broadcastVoiceDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="headline">Broadcast Reminder</v-card-title>
                <div class="font-weight-medium mb-3 px-3">
                    You are about to broadcast a call to all parents who haven't
                    answered the screening
                </div>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        dark
                        color="default"
                        @click="broadcastVoiceDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="broadcastVoice"
                    >
                        confirm
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog> -->
        <v-dialog v-model="broadcastSms.dialog" max-width="500" persistent>
            <v-card class="pa-2">
                <v-card-title class="headline pt-2"
                    >Broadcast Reminder (Text)</v-card-title
                >
                <!-- <div class="font-weight-medium mb-3 px-3">
                    You are about to broadcast a call to all parents who haven't
                    answered the screening
                </div> -->
                <v-text-field
                    class="mb-1 px-3"
                    autocomplete="new-password"
                    label="From Phone"
                    v-model="broadcastSms.fromPhone"
                    ref="fromPhoneSms"
                    :rules="[rules.required]"
                    :mask="phoneMask"
                ></v-text-field>
                <v-textarea
                    class="mb-3 px-3"
                    hide-details
                    label="Type a Message..."
                    v-model="broadcastSms.text"
                    ref="broadcastSmsText"
                    :rules="[rules.required]"
                    rows="4"
                    outline
                ></v-textarea>
                <v-select
                    class="px-3 mb-1"
                    :items="['CEL', 'MCEL']"
                    label="Phone Type"
                    multiple
                    :rules="[rules.required]"
                    ref="broadcastSmsPhoneTypes"
                    v-model="broadcastSms.phoneTypes"
                    @change="onSmsPhoneTypeSeleceted"
                ></v-select>

                <div
                    class="mx-3 pa-2"
                    style="background-color: #4caf50; color: #fff"
                >
                    Phone Numbers<span class="ml-2">{{
                        broadcastSms.phoneNumbers.length +
                            "/" +
                            (broadcastSms.sentNumbers
                                ? broadcastSms.sentNumbers.length
                                : 0)
                    }}</span>
                </div>

                <div
                    style="height: 350px; overflow-y: auto; border: 2px solid #4caf50"
                    class="mx-3 px-2 py-3 mb-2"
                >
                    <div
                        class="text-xs-center mb-5"
                        v-if="!broadcastSms.phoneNumbers.length && !loading"
                    >
                        No Phone Numbers.
                    </div>
                    <v-layout justify-center v-if="loading">
                        <v-progress-circular
                            v-if="loading"
                            :size="70"
                            :width="7"
                            color="success"
                            indeterminate
                        ></v-progress-circular>
                    </v-layout>

                    <div
                        v-if="!loading"
                        v-for="(number, index) in broadcastSms.phoneNumbers"
                        class="px-2"
                    >
                        <v-layout row>
                            <v-icon
                                v-if="isSent(number)"
                                class="mr-3"
                                dark
                                color="success"
                                >mdi-message-text</v-icon
                            >
                            <v-icon
                                v-if="!isSent(number)"
                                class="mr-3"
                                dark
                                color="#fdb400"
                                >mdi-message-processing</v-icon
                            >
                            <div class="width-200">
                                {{ number.name }}
                            </div>
                            <div>{{ number.phoneNum }}</div>
                        </v-layout>
                        <v-divider
                            class="mt-2 pb-2"
                            v-if="index + 1 < broadcastSms.phoneNumbers.length"
                            :key="index"
                        ></v-divider>
                    </div>
                </div>
                <v-card-actions class="mr-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        dark
                        color="default"
                        @click="closeBroadcastSmsDialog()"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :disabled="!broadcastSms.phoneNumbers.length"
                        :loading="processing"
                        color="success"
                        @click="sendMessage"
                    >
                        send
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="broadcastCall.dialog" max-width="550" persistent>
            <v-card class="pa-2">
                <v-card-title class="headline pt-2"
                    >Broadcast Reminder (Call)</v-card-title
                >
                <v-text-field
                    class="mb-1 px-3"
                    autocomplete="new-password"
                    label="From Phone"
                    v-model="broadcastCall.fromPhone"
                    ref="fromPhoneCall"
                    :rules="[rules.required]"
                    :mask="phoneMask"
                ></v-text-field>
                <v-textarea
                    class="mb-3 px-3"
                    hide-details
                    label="Type a Message..."
                    v-model="broadcastCall.text"
                    ref="broadcastCallText"
                    :rules="[rules.required]"
                    rows="4"
                    outline
                ></v-textarea>
                <v-select
                    class="px-3 mb-1"
                    :items="['CEL', 'MCEL', 'PHON']"
                    label="Phone Type"
                    multiple
                    :rules="[rules.required]"
                    ref="broadcastCallPhoneTypes"
                    v-model="broadcastCall.phoneTypes"
                    @change="onCallPhoneTypeSeleceted"
                ></v-select>

                <div
                    class="mx-3 pa-2"
                    style="background-color: #4caf50; color: #fff"
                >
                    Phone Numbers<span class="ml-2">{{
                        broadcastCall.phoneNumbers.length +
                            "/" +
                            (broadcastCall.sentNumbers
                                ? broadcastCall.sentNumbers.length
                                : 0)
                    }}</span>
                </div>

                <div
                    style="height: 350px; overflow-y: auto; border: 2px solid #4caf50"
                    class="mx-3 px-2 py-3 mb-2"
                >
                    <div
                        class="text-xs-center mb-5"
                        v-if="!broadcastCall.phoneNumbers.length && !loading"
                    >
                        No Phone Numbers.
                    </div>
                    <v-layout justify-center v-if="loading">
                        <v-progress-circular
                            v-if="loading"
                            :size="70"
                            :width="7"
                            color="success"
                            indeterminate
                        ></v-progress-circular>
                    </v-layout>

                    <div
                        v-if="!loading"
                        v-for="(number, index) in broadcastCall.phoneNumbers"
                        class="px-2"
                    >
                        <v-layout row>
                            <v-icon
                                v-if="isCallMade(number)"
                                class="mr-3"
                                dark
                                color="success"
                                >mdi-phone</v-icon
                            >
                            <v-icon
                                v-if="!isCallMade(number)"
                                class="mr-3"
                                dark
                                color="#fdb400"
                                >mdi-phone</v-icon
                            >
                            <div class="width-200">
                                {{ number.name }}
                            </div>
                            <div class="width-150">{{ number.phoneNum }}</div>
                            <button
                                style="background-color: #fff; color: #4caf50; font-size: 14px;"
                                @click="openTestCallDialog(number)"
                            >
                                TEST
                            </button>
                            <!-- <v-btn
                                class="ml-4 my-0"
                                small
                                flat
                                color="success"
                                @click="openTestCallDialog(number)"
                                >Test</v-btn
                            > -->
                        </v-layout>
                        <v-divider
                            class="mt-2 pb-2"
                            v-if="index + 1 < broadcastCall.phoneNumbers.length"
                            :key="index"
                        ></v-divider>
                    </div>
                </div>
                <v-card-actions class="mr-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        dark
                        color="default"
                        @click="closeBroadcastCallDialog()"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :disabled="!broadcastCall.phoneNumbers.length"
                        :loading="processing"
                        color="success"
                        @click="broadcastVoice"
                    >
                        send
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="broadcastCall.testDialog" max-width="400" persistent>
            <v-card class="pa-2">
                <v-card-title class="headline pt-2">Test Call</v-card-title>
                <v-text-field
                    class="mb-1 px-3"
                    label="Test Phone"
                    v-model="broadcastCall.testPhone"
                    :rules="[rules.required]"
                    :mask="phoneMask"
                ></v-text-field>
                <v-card-actions class="mr-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        dark
                        color="default"
                        @click="broadcastCall.testDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="makeTestCall"
                    >
                        send
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import moment from "moment";
import { toISOLocal, skip } from "../../utils/helpers.js";
import * as firebase from "firebase/app";
import "firebase/database";

export default {
    data: () => ({
        title: "Covid Screening By Student",
        columns: [
            {
                field: "passed",
                isIcon: true,
                type: "boolean",
                template: "icon",
                alignment: "center",
                visible: true,
                allowFiltering: false,
                allowHeaderFiltering: false,
                allowHiding: false,
                allowSearch: false,
                cssClass: "width-25",
                headerFilter: {
                    allowSearch: false,
                    groupInterval: undefined,
                    height: undefined,
                    searchMode: "contains",
                    width: undefined,
                },
                icon: (value, data) => {
                    if (data.status == "UNANSWERED") return "mdi-close-circle";

                    return value === true ? "mdi-check-circle" : "mdi-flag";
                },
                iconColor: (value, data) => {
                    if (data.status == "UNANSWERED") return "#aeb8bf";

                    return value === true ? "success" : "#f35123";
                },
            },
            {
                field: "studentID",
                label: "Student ID",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "familyID",
                label: "Family ID",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Name",
                field: "name",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Section",
                field: "section",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Class",
                field: "class",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Building",
                field: "building",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Date",
                field: "date",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                visible: true,
            },
            {
                label: "For Date",
                field: "forDate",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                visible: false,
            },
            {
                label: "Caller ID",
                field: "callerID",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Status",
                field: "status",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Passed",
                field: "passed",
                type: "boolean",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Symptoms",
                field: "symptoms",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Tested Positive",
                field: "testedPositive",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Came In Contact",
                field: "cameInContact",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Traveled Abroad",
                field: "traveledAbroad",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Source",
                field: "source",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Last Updated",
                field: "lastUpdated",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                visible: false,
            },
            {
                label: "Home Phone",
                field: "homePhone",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Cellphone",
                field: "cellPhone",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Mother Phone",
                field: "motherPhone",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],

        actions: [],
        url: "",
        broadcastVoiceDialog: false,

        processing: false,

        rules: {
            required: (value) => !!value || "Required.",
        },

        phoneMask: "###-###-####",

        broadcastSms: {
            dialog: false,
            phoneTypes: ["CEL"],
            fromPhone: "7185040146",
            requestID: null,
            text:
                "This is a reminder From UTA. You still haven't answered the Covid-19 screening for today. Please call back this # or text the word 'NEW' to start a screening session. Thank You",
            phoneNumbers: [],
            sentNumbers: [],
        },

        broadcastCall: {
            dialog: false,
            phoneTypes: ["PHON"],
            fromPhone: "7185040146",
            requestID: null,
            text:
                "Hi. this is U.T.A calling. You still haven't answered the Covid-19 screening for today. press 1 to be transferred to the covid 19 screening line.",
            phoneNumbers: [],
            sentNumbers: [],
            testDialog: false,
            testPhone: "",
            testAccount: "",
        },

        loading: false,
        smsEventRef: "",
        callEventRef: "",

        firebaseConfig: {
            apiKey: "AIzaSyCtYeCL8HkqlMKJh6g6jcDvoH60-woVbDE",
            authDomain: "utaw.firebaseapp.com",
            databaseURL: "https://utaw.firebaseio.com",
            projectId: "project-683582246459980907",
            storageBucket: "project-683582246459980907.appspot.com",
            messagingSenderId: "193425158146",
            appId: "1:193425158146:web:f1ae134a803fb75832371b",
        },

        building: "",
        forDate: "",

        unansweredCount: 0,
        passedCount: 0,
        notPassedCount: 0,
    }),
    created() {},
    methods: {
        setupSmsEventListner() {
            if (!firebase.apps.length) {
                firebase.initializeApp(this.firebaseConfig);
            }

            var database = firebase.database();
            var ref = firebase.database().ref("sms-progress");

            const query = ref
                .orderByChild("RequestID")
                .equalTo(this.broadcastSms.requestID)
                .limitToLast(1);

            this.smsEventRef = query;

            this.smsEventRef.on(
                "value",
                (snapshot) => {
                    if (snapshot.val()) {
                        this.broadcastSms.sentNumbers = snapshot.val()[
                            Object.keys(snapshot.val())[0]
                        ].PhoneNumbers;
                    }
                },
                function(error) {
                    console.log("Error: " + error.code);
                }
            );
        },
        setupCallEventListner() {
            if (!firebase.apps.length) {
                firebase.initializeApp(this.firebaseConfig);
            }

            var database = firebase.database();
            var ref = firebase.database().ref("call-progress");

            const query = ref
                .orderByChild("RequestID")
                .equalTo(this.broadcastCall.requestID)
                .limitToLast(1);

            this.callEventRef = query;

            this.callEventRef.on(
                "value",
                (snapshot) => {
                    if (snapshot.val()) {
                        this.broadcastCall.sentNumbers = snapshot.val()[
                            Object.keys(snapshot.val())[0]
                        ].PhoneNumbers;
                    }
                },
                function(error) {
                    console.log("Error: " + error.code);
                }
            );
        },
        async beforeSetupGrid() {
            this.actions.push({
                text: "Broadcast Reminder",
                isMenu: true,
                items: [
                    {
                        value: "call",
                        text: "Call",
                    },
                    {
                        value: "text",
                        text: "Text",
                    },
                ],
                value: "BroadcastReminder",
                action: this.openReminder,
            });
            // this.actions.push({
            //     text: "Broadcast Reminder (Call)",
            //     action: this.openBroadcastVoiceDialog,
            // });

            // this.actions.push({
            //     text: "Broadcast Reminder (Text)",
            //     action: this.openBroadcastSmsDialog,
            //     loading: false,
            // });

            this.forDate = toISOLocal(new Date(moment())).substr(0, 10);

            this.actions.push({
                text: "For Date",
                type: "datepicker",
                value: this.forDate,
                onChanged: this.onDateChanged,
                align: "left",
            });

            this.building =
                localStorage.getItem("screeningBuildingFilter") || "";

            if (this.building == "undefined") this.building = undefined;

            // this.actions.push({
            //     text: "BUILDING:",
            //     type: "select",
            //     clearable: true,
            //     values: [
            //         "110",
            //         "720",
            //         "656",
            //         "128",
            //         "177",
            //         "241",
            //         "212",
            //         "60H",
            //         "75",
            //         "590",
            //         "25",
            //         "125",
            //         "UTA",
            //         "62",
            //     ],
            //     value: this.building,
            //     align: "left",
            //     onSelected: this.onBuildingSelected,
            // });

            this.url =
                "covidScreeningByStudent?forDate=" +
                this.forDate +
                (this.building ? "&building=" + this.building : "");

            // this.actions.push({
            //     align: "left",
            //     text: this.getStatusText(),
            //     getText: this.getStatusText,
            //     type: "text",
            // });
        },
        onDateChanged(value) {
            this.forDate = value;
            this.url =
                "covidScreeningByStudent?forDate=" +
                this.forDate +
                (this.building ? "&building=" + this.building : "");

            this.$refs.grid.reloadDataSource(this.url);
        },
        onBuildingSelected(value) {
            this.building = value;

            localStorage.setItem("screeningBuildingFilter", this.building);

            this.url =
                "covidScreeningByStudent?forDate=" +
                this.forDate +
                (this.building ? "&building=" + this.building : "");

            this.$refs.grid.reloadDataSource(this.url);
        },
        getTemplateName(data) {
            if (data.status == "UNANSWERED") return "";

            if (data.source == "IVR") {
                return "screening-ivr-call-details";
            }

            return "covid-screening-sms-messages";
        },
        openReminder(option) {
            if (option == "call") return this.openBroadcastVoiceDialog();

            return this.openBroadcastSmsDialog();
        },
        async onLoaded(result) {
            const url = this.$refs.grid.getDataSourceURL();

            const statuses = await this.$http.post(
                "api/covidScreening/getScreeningStatuses",
                {
                    url,
                }
            );

            this.unansweredCount = statuses.unanswered;
            this.passedCount = statuses.passed;
            this.notPassedCount = statuses.notPassed;
        },
        getStatusText() {
            return (
                `<div class="layout row" style="margin: 0px; !important; font-size: 1.125rem !important;">
                    <div class="font-weight-medium">UNANSWERED: <span class="font-weight-light mr-2">` +
                this.unansweredCount +
                `</span></div>
                    <div class="font-weight-medium">PASSED: <span class="font-weight-light mr-2">` +
                this.passedCount +
                `</span></div>
                    <div class="font-weight-medium">NOT PASSED: <span class="font-weight-light">` +
                this.notPassedCount +
                `</span></div>
                    </div>`
            );
        },
        async openBroadcastVoiceDialog() {
            this.broadcastCall.dialog = true;

            this.loading = true;

            //this.students = students.filter((s) => s.status == "UNANSWERED");

            this.broadcastCall.phoneNumbers = await this.loadNumbers(
                this.broadcastCall.phoneTypes
            );

            this.loading = false;
        },
        async openBroadcastSmsDialog() {
            this.broadcastSms.dialog = true;

            this.loading = true;

            //const students = await this.$refs.grid.loadAllWithFilter();

            //this.students = students.filter((s) => s.status == "UNANSWERED");

            // const lastMessage = this.students.find(
            //     (s) => s.name == "Friedman, Leah"
            // );
            // const index = this.students.indexOf(lastMessage);
            // this.students = skip(this.students, index);

            this.broadcastSms.phoneNumbers = await this.loadNumbers(
                this.broadcastSms.phoneTypes
            );

            this.loading = false;
        },
        async loadNumbers(phoneTypes) {
            // const numbers = await this.$http.post(
            //     "api/broadcast/getPhoneNumbers?",
            //     {
            //         accountIDs: this.students.map((a) => a.familyID),
            //         types: phoneTypes,
            //     }
            // );

            const date = moment(this.forDate).format("L");

            let numbers = await this.$http.get(
                "api/covidScreening/getPhoneNumbersToBroadcast?forDate=" +
                    date +
                    "&phoneTypes=" +
                    phoneTypes
            );

            numbers = numbers.filter((n) => n.accountID == "WERYOEL");

            return numbers;
        },
        getLastName(accountID) {
            if (!accountID) return;

            const student = this.students.find(
                (s) => s.familyID.trim() == accountID.trim()
            );

            let name = student ? student.name : accountID;

            return name;
        },
        async broadcastVoice() {
            if (!this.validateCallFields()) return;

            try {
                this.processing = true;

                this.broadcastCall.requestID = Math.floor(
                    Math.random() * 10000000
                );

                this.setupCallEventListner();

                await this.$http.post(
                    "api/covidScreening/broadcastCallReminder?",
                    {
                        phoneNumbers: this.broadcastCall.phoneNumbers,
                        text: this.broadcastCall.text,
                        from:
                            "1" + this.broadcastCall.fromPhone.replace(" ", ""),
                        requestID: this.broadcastCall.requestID,
                        user: this.$store.state.authentication.user,
                    }
                );

                this.processing = false;
                this.closeBroadcastCallDialog();

                this.$notify({
                    group: "notification",
                    text: "Calls Broadcast",
                    type: "success",
                });

                this.callEventRef.off();
            } catch (e) {
                this.processing = false;

                this.callEventRef.off();
            }
        },
        async makeTestCall() {
            if (!this.broadcastCall.testPhone) {
                this.$notify({
                    group: "notification",
                    text: "Please enter your phone number",
                    type: "error",
                });

                return false;
            }

            try {
                this.processing = true;

                this.broadcastCall.requestID = Math.floor(
                    Math.random() * 10000000
                );

                await this.$http.post(
                    "api/covidScreening/broadcastCallReminder?",
                    {
                        phoneNumbers: [this.broadcastCall.testAccount],
                        text: this.broadcastCall.text,
                        testPhone: this.broadcastCall.testPhone,
                        from:
                            "1" + this.broadcastCall.fromPhone.replace(" ", ""),
                        requestID: this.broadcastCall.requestID,
                        user: this.$store.state.authentication.user,
                    }
                );

                this.processing = false;
                this.broadcastCall.testDialog = false;
            } catch (e) {
                this.processing = false;
            }
        },
        async onSmsPhoneTypeSeleceted(value) {
            this.broadcastSms.phoneNumbers = await this.loadNumbers(value);
        },
        async onCallPhoneTypeSeleceted(value) {
            this.broadcastCall.phoneNumbers = await this.loadNumbers(value);
        },
        closeBroadcastSmsDialog() {
            this.students = [];
            this.broadcastSms.sentNumbers = [];
            this.broadcastSms.phoneNumbers = [];
            this.broadcastSms.phoneTypes = ["CEL"];

            this.broadcastSms.dialog = false;
        },
        closeBroadcastCallDialog() {
            this.students = [];
            this.broadcastCall.sentNumbers = [];
            this.broadcastCall.phoneNumbers = [];
            this.broadcastCall.phoneTypes = ["PHON"];

            this.broadcastCall.dialog = false;
        },
        validateSmsFields() {
            if (!this.broadcastSms.fromPhone) {
                this.$notify({
                    group: "notification",
                    text: "Missing From Phone",
                    type: "error",
                });

                return false;
            }

            if (!this.broadcastSms.text) {
                this.$notify({
                    group: "notification",
                    text: "Missing Message",
                    type: "error",
                });

                return false;
            }

            if (!this.broadcastSms.phoneTypes.length) {
                this.$notify({
                    group: "notification",
                    text: "Missing Phone Type",
                    type: "error",
                });

                return false;
            }

            return true;
        },
        validateCallFields() {
            if (!this.broadcastCall.fromPhone) {
                this.$notify({
                    group: "notification",
                    text: "Missing From Phone",
                    type: "error",
                });

                return false;
            }

            if (!this.broadcastCall.text) {
                this.$notify({
                    group: "notification",
                    text: "Missing Message",
                    type: "error",
                });

                return false;
            }

            if (!this.broadcastCall.phoneTypes.length) {
                this.$notify({
                    group: "notification",
                    text: "Missing Phone Type",
                    type: "error",
                });

                return false;
            }

            return true;
        },
        isSent(phoneNumber) {
            if (!this.broadcastSms.sentNumbers) return;

            return this.broadcastSms.sentNumbers.find(
                (p) => p.Number == phoneNumber.phoneNum
            );
        },
        isCallMade(phoneNumber) {
            if (!this.broadcastCall.sentNumbers) return;

            return this.broadcastCall.sentNumbers.find(
                (p) => p.Number == phoneNumber.phoneNum
            );
        },
        openTestCallDialog(account) {
            this.broadcastCall.testAccount = account;
            this.broadcastCall.testDialog = true;
        },
        async sendMessage() {
            if (!this.validateSmsFields()) return;

            try {
                this.processing = true;

                this.broadcastSms.requestID = Math.floor(
                    Math.random() * 10000000
                );

                this.setupSmsEventListner();

                await this.$http.post(
                    "api/covidScreening/broadcastSMSReminder?",
                    {
                        phoneNumbers: this.broadcastSms.phoneNumbers,
                        text: this.broadcastSms.text,
                        from:
                            "1" + this.broadcastSms.fromPhone.replace(" ", ""),
                        requestID: this.broadcastSms.requestID,
                        user: this.$store.state.authentication.user,
                    }
                );

                this.processing = false;
                this.closeBroadcastSmsDialog();

                this.$notify({
                    group: "notification",
                    text: "Messages Sent",
                    type: "success",
                });

                this.smsEventRef.off();
            } catch (e) {
                this.processing = false;

                this.smsEventRef.off();
            }
        },
    },
};
</script>
<style></style>
